import Tooltip from "react-bootstrap/Tooltip";

export const toolTip = ({ text = "", props = null }) => (
    <Tooltip id="button-tooltip" {...props}>
        {text}
    </Tooltip>
);


